import axios from "axios";
import { Navigate, useNavigate, useLocation } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import { navigateTo } from "../services/Navigation";

const isLocalhost = window.location.hostname === "localhost";
export const BackendBaseURL = isLocalhost ? "http://localhost/Bazargani-Rating/bazargani-rating-backend/public/" : "/bazargani-rating-backend/public/";
// export const BackendBaseURL = "http://bazarganiad.ir/bazargani-rating-backend/public/";
export const AxiosBaseURL = BackendBaseURL + "api/"


const token = localStorage.getItem('token')

const AxiosAdmin = axios.create({
    baseURL: AxiosBaseURL + 'admin/',
    timeout: 360000,
    headers: { 
        'Accept': 'application/json',
        "Content-Type": "application/json",
        // 'Access-Control-Max-Age':'360000',
        'Access-Control-Allow-Origin':'*',
        'Authorization': token ? "Bearer " + token : '',
    }
});

// AxiosAdmin.interceptors.request.use(
//     async (config) => {
//         const token = localStorage.getItem('token');

//         if (!token) {
//             return Promise.reject(new Error('No token available.'));
//         }

//         config.headers.Authorization = `Bearer ${token}`;
//         return config;
//     },
//     (error) => {
//         return Promise.reject(error);
//     }
// );

const AxiosOperator = axios.create({
    baseURL: AxiosBaseURL + 'operator/',
    timeout: 360000,
    headers: { 
        'Accept': 'application/json',
        "Content-Type": "application/json",
        // 'Access-Control-Max-Age':'360000',
        'Access-Control-Allow-Origin':'*',
        'Authorization': token ? "Bearer " + token : '',
    }
})

const AxiosUser = axios.create({
    baseURL: AxiosBaseURL + 'user/',
    timeout: 360000,
    headers: { 
        'Accept': 'application/json',
        "Content-Type": "application/json",
        // 'Access-Control-Max-Age':'360000',
        'Access-Control-Allow-Origin':'*',
        'Authorization': token ? "Bearer " + token : '',
    }
})

const AxiosGeneral = axios.create({
    baseURL: AxiosBaseURL,
    timeout: 360000,
    headers: { 
        'Accept': 'application/json',
        "Content-Type": "application/json",
        // 'Access-Control-Max-Age':'360000',
        'Access-Control-Allow-Origin':'*',
        'Authorization': token ? "Bearer " + token : '',
    }
})

AxiosGeneral.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem('token');

        if (!token) {
            return Promise.reject(new Error('AxiosGeneral - No token available.'));
        }

        config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);




/*
axios.interceptors.request.use(function (config) {
    console.log('axios.interceptors.request 1')
    // Do something before request is sent
    return config;
  }, function (error) {
    console.log('axios.interceptors.request 2')
    // Do something with request error
    return Promise.reject(error);
});
*/

  
AxiosUser.interceptors.response.use(
    (response) => {
        console.log('axios.interceptors.response - response:',response)
        // اگر پاسخ موفق بود، فقط برگردونش
        return response;
    },
    (error) => {
        console.log('axios.interceptors.response - error:',error)
        if (error.response) {
            const status = error.response.status;
            console.log('status:',status)
            console.log('error.response:',error.response)
            const message = error.response.data?.message || 'خطایی رخ داده است.';

            switch (status) {
                case 400:
                    toast.error('درخواست نامعتبر است. ' + message);
                    break;

                case 401:
                    toast.warning('نشست کاربری شما منقضی شده یا وارد سیستم نشده‌اید. لطفاً دوباره وارد شوید.');
                    setTimeout(() => {
                        navigateTo("/login", { replace: true });
                    }, 500);
                    break;

                case 403:
                    toast.error('شما مجوز دسترسی به این بخش را ندارید.');
                    setTimeout(() => {
                        navigateTo("/403", { replace: true });
                    }, 500);
                    break;

                case 404:
                    toast.error('اطلاعات یا صفحه مورد نظر یافت نشد. (' + message + ')');
                    setTimeout(() => {
                        navigateTo("/404", { replace: true });
                    }, 500);
                    break;

                case 500:
                    toast.error('خطایی در سرور رخ داده است. لطفاً چند دقیقه دیگر دوباره تلاش کنید.');
                    break;

                default:
                    toast.error('خطایی رخ داده است.');
                    // toast.error(message || 'خطایی رخ داده است.');
            }

        } else if (error.request) {
            // درخواست ارسال شده ولی پاسخی دریافت نشده است
            toast.error('ارتباط با سرور برقرار نشد. لطفاً اتصال اینترنت یا وضعیت سرور را بررسی کرده و دوباره تلاش کنید.');

        } else {
            // خطا هنگام تنظیم درخواست
            toast.error('در ارسال درخواست خطایی رخ داد: ' + error.message);
        }


        return Promise.reject(error);
    }
);



// export function AxiosErrorHandling(error, setServerErrors, flashMessageData, setFlashMessageData, setAccessDenied) {
function AxiosErrorHandling(error) {
    console.log('error:',error)
    // console.log('error.response:',error.response)
    // console.log('error.response.status:',error.response.status)
    // console.log('error:',error.response.data)
    // console.log('error:',error.response.data.message)

    if(parseInt(error?.response?.status) === 401) {
        console.log('HERE 401')
        // return <Navigate to={"/login"} replace />
        window.location.href = '/login';
    } else if(parseInt(error?.response?.status) === 500) {
        console.log('HERE 500')
        toast.error(<div>خطای سروری!<br/>{error?.response?.data?.message}</div>)
    } else if(parseInt(error?.response?.status) === 400) {
        console.log('HERE 400')
        toast.error(<div>خطای دسترسی!<br/>{error?.response?.data?.message}</div>)
        window.location.href = '/dashboard';
    }

   
    
    // if(error.response.status === 500) {
    //     let message = ''//dictionary.message500
    //     if(error?.response?.message !== undefined && error?.response?.message !== '')
    //         message = message + '\n' + error.response.message

    //     setFlashMessageData([...flashMessageData, {message:message,messageStatus:'danger', duration: 10}])
    // }
    // if(error.response.status === 401)
    //     setAccessDenied(true)
    // else {
    //     if(error.response.data?.displayType === 'external')
    //         setAccessDenied(true)
    //     else {
    //         setServerErrors(error.response.data)                    
    //     }
    // }
    // console.log('AxiosErrorHandling - start')
    // console.error({ error });
    if (error.response) {
        // console.log('case 1')
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        // console.log(error.response.data.status);
        // console.log(error.response.headers);
    } else if (error.request) {
        // console.log('case 2')
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        // console.log(error.request);
    } else {
        // console.log('case 3')
        // Something happened in setting up the request that triggered an Error
        // console.log('Error', error.message);
    }
    // console.log('AxiosErrorHandling - end')
}

const AxiosConfigFileUpload = {
    headers: {
        'content-type': 'multipart/form-data'
    }
}

export {AxiosAdmin, AxiosOperator, AxiosUser, AxiosGeneral, AxiosConfigFileUpload, AxiosErrorHandling};